import { NavigateFunction } from "react-router-dom";

import { SlideFlagPOST } from "custom-models";

import {
  FLAG_CREATE_REQUEST,
  FLAG_MISLABELED_CREATE_REQUEST,
} from "./constants";

type createFlagPayload = {
  form: Partial<SlideFlagPOST>;
  url?: string;
  closeModal: Function;
  navigate?: NavigateFunction;
};

export const createFlag = (payload: createFlagPayload) => {
  return {
    type: FLAG_CREATE_REQUEST,
    payload,
  };
};

export const createMislabeledFlag = (payload: createFlagPayload) => {
  return {
    type: FLAG_MISLABELED_CREATE_REQUEST,
    payload,
  };
};
